import {
	IconArrowUpRightOutline18 as ArrowUpRight,
	IconCircleInfoOutline18 as Info,
} from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { Button, IconButton } from "@productlane/ui"

interface Props {
	article: string
	className?: string
	variant?: "text" | "icon" | "link"
	label?: string
}

export const HowItWorksButton = ({
	article,
	className,
	variant = "text",
	label = "How it works",
}: Props) => {
	const handleClick = () => {
		// @ts-expect-error Global widget calls
		// eslint-disable-next-line
		window.Productlane.openDocs(article)
	}

	if (variant === "icon") {
		return (
			<IconButton
				className={cn("dark:bg-gray-700/70", className)}
				variant={"outline"}
				Icon={Info}
				onClick={handleClick}
			/>
		)
	}

	if (variant === "link") {
		// Inline, not inline-flex, so the label keeps the surrounding text baseline.
		return (
			<button
				type="button"
				onClick={handleClick}
				className={cn(
					"inline text-primary hover:underline focus-visible:underline focus-visible:outline-none",
					className,
				)}
			>
				{label}
				<ArrowUpRight className="ml-0.5 inline size-3 align-[-0.1em]" />
			</button>
		)
	}

	return (
		<Button
			className={cn("dark:bg-gray-700/70", className)}
			variant={"outline"}
			onClick={handleClick}
		>
			{label}
		</Button>
	)
}
